import React from "react";
import ReactDOM from "react-dom";
import Modal from "react-modal";
import { Provider } from 'react-redux';
import rootReducer from "./services/reducer";
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

import 'mdb-react-ui-kit/dist/css/mdb.min.css';
// import "@fortawesome/fontawesome-free/css/all.min.css"; // Moved to CDN in public/index.html to fix css-loader build error
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

//customer support widget
import "components/CustomerSupport/index.css";


import App from "./App";
import { loadStocksFromFirestore } from 'services/actions';

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)));

// Hydrate store from Firestore on boot; hardcoded store data is used as fallback if collections are empty
store.dispatch(loadStocksFromFirestore());

Modal.setAppElement("#root");


const WrappedApp = () => (
  <Provider store={store}>
    <App />
  </Provider>
  );

ReactDOM.render(  
  <WrappedApp />,
  document.getElementById("root")
);
